export const base_path = "";
// export const base_path = "/";
